import { CashTypeEnum } from "../enums/CashTypeEnum";
import { StockTypeEnum } from "../enums/StockTypeEnum";
import { TransactionTypeEnum } from "../enums/TransactionTypeEnum";
import { TagValues } from "../Tag";
import { SoftwareVersionsFilter } from "../updates/SoftwareVersionsFilter";
import { DateRangeTypeEnum } from "./DateRangeTypeEnum";

export class WidgetFilter {
    byModel: string[] = [];
    byFolder: number[] = [];
    bySoftware: SoftwareVersionsFilter = new SoftwareVersionsFilter();
    byTag: TagValues[] = [];
    byInstallationName: string[] = [];

    // cash count
    byCashType: CashTypeEnum[] = [];
    stockType: StockTypeEnum[] = [];
    byBagSize: number[] = [];

    // cash distribution
    currencyList: string[] = [];

    // transaction
    dateRangeType: DateRangeTypeEnum = DateRangeTypeEnum.Dynamic;
    daysInterval: number = 15;
    startDate: Date = new Date();
    endDate: Date = new Date();
    transTypes: Array<TransactionTypeEnum> = [];
    currency: string = "";
    userId: string = "";
    channelId: string = "";
    shiftNumber: string = "";

    fillFromJson(data: any) {
        this.byModel = data.ByModel || [];
        this.byInstallationName = data.ByInstallationName || [];
        this.byFolder = data.ByFolder || [];
        this.bySoftware = new SoftwareVersionsFilter();
        if (data.BySoftware) {
            this.bySoftware.parse(data.BySoftware);
        }
        this.byTag = [];
        if (data.ByTag) {
            data.ByTag.forEach((c) => {
                var t = new TagValues();
                t.parse(c);
                this.byTag.push(t);
            });
        }
        this.byCashType = data.ByCashType || [];
        this.stockType = data.StockType || [];
        this.byBagSize = data.ByBagSize || [];

        this.currencyList = data.CurrencyList || [];

        this.dateRangeType = data.DateRangeType;
        this.daysInterval = data.DaysInterval;
        this.startDate = data.StartDate;
        this.endDate = data.EndDate;
        this.transTypes = data.TransTypes || [];
        this.currency = data.Currency;
        this.userId = data.UserId;
        this.channelId = data.ChannelId;
        this.shiftNumber = data.ShiftNumber;
    }

    clone(): WidgetFilter {
        var result = new WidgetFilter();

        result.byModel = [...this.byModel];
        result.byInstallationName = [...this.byInstallationName];
        result.byFolder = [...this.byFolder];
        result.bySoftware = this.bySoftware.clone();
        result.byTag = [...this.byTag];

        result.byCashType = [...this.byCashType];
        result.stockType = [...this.stockType];
        result.byBagSize = [...this.byBagSize];

        result.currencyList = [...this.currencyList];

        result.dateRangeType = this.dateRangeType;
        result.daysInterval = this.daysInterval;
        result.startDate = this.startDate;
        result.endDate = this.endDate;
        result.transTypes = this.transTypes;
        result.currency = this.currency;
        result.userId = this.userId;
        result.channelId = this.channelId;
        result.shiftNumber = this.shiftNumber;

        return result;
    }
}
